
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/websitebuilderselect/privacy-policy",
      function () {
        return require("private-next-pages/websitebuilderselect/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/websitebuilderselect/privacy-policy"])
      });
    }
  